<script lang="ts" setup>
import { Popup } from "vant";
import { isMobile } from "@/modules/common";
import { useGlobalUser } from "@/stores/globalUser";
import { watch } from "vue";
import { useWindowSize } from "@vueuse/core";
import { state as themeState } from "@/composable/settings/theme";
import { useDiscordGift } from "@/composable/useDiscordGift";
// import { useRoute } from "vue-router";
import { useRouteQuery } from "@vueuse/router";

const userStore = useGlobalUser();
// const route = useRoute();
const { width } = useWindowSize();
const { isRedeeming } = useDiscordGift();
const isCN = !!import.meta.env.VITE_IS_CN;
const mode = useRouteQuery("mode");
watch(
  () => userStore.isLogin,
  () => {
    userStore.loginModal.show = false;
  }
);
</script>
<template>
  <Popup
    v-model:show="userStore.loginModal.show"
    :class="{
      'border border-white/10': !isMobile(),
    }"
    :closeOnClickOverlay="false"
    :position="isMobile() && width < 640 ? 'bottom' : 'center'"
    class="w-full bg-base-200 overflow-hidden sm:max-w-md overflow-y-auto"
    overlay-class="backdrop-blur"
    round
  >
    <button
      class="absolute right-2 top-2 z-20"
      @click="userStore.loginModal.show = false"
    >
      <i class="icon-xmark iconfont text-2xl text-white" />
    </button>
    <!--    <BorderBeam />-->
    <!--    <DotPattern-->
    <!--      class="[mask-image:radial-gradient(250px_circle_at_center,white,transparent)]"-->
    <!--    />-->
    <div
      class="w-full rounded flex flex-col justify-center items-center relative z-10"
    >
      <div class="w-full relative">
        <div
          class="w-full min-h-[100px] flex items-center justify-center bg-primary"
        >
          <p class="text-primary-content text-2xl mt-4">
            {{ mode === "register" ? "请注册" : "请登录" }}
          </p>
        </div>
      </div>
      <div class="relative w-full">
        <!-- <RetroGrid /> -->
        <div
          class="p-6 pt-4 md:p-12 md:pt-10 w-full flex flex-col gap-4 items-center justify-center relative"
        >
          <ShineBorder
            v-if="isRedeeming && !isCN"
            class="px-4 py-2 flex flex-col gap-1"
          >
            <div class="flex items-center gap-2 relative">
              <i class="iconify-color noto--wrapped-gift text-lg" />
              <i class="iconify mingcute--transfer-line" />
              <i class="iconify mingcute--discord-fill text-lg" />
            </div>
            <span>{{ $t("Message.redeemLoginTip") }}</span>
          </ShineBorder>
          <UserLogin :theme="themeState" class="w-full relative z-10" />
          <!-- <div class="text-xs text-center">
            {{ $t("About.policyAnnounce") }}
            <span
              class="cursor-pointer text-primary"
              @click="
                router.push({
                  name: 'policy',
                  query: { type: 'terms-of-service' },
                })
              "
            >
              {{ $t("About.termsOfService") }}
            </span>
            ,
            <span
              class="cursor-pointer text-primary"
              @click="
                router.push({
                  name: 'policy',
                  query: { type: 'privacy-policy' },
                })
              "
            >
              {{ $t("About.privacyPolicy") }} </span
            >,
            <span
              class="cursor-pointer text-primary"
              @click="
                router.push({
                  name: 'policy',
                  query: { type: 'content-removal-policy' },
                })
              "
            >
              {{ $t("About.contentRemovalPolicy") }} </span
            >,
            <span
              class="cursor-pointer text-primary"
              @click="
                router.push({
                  name: 'policy',
                  query: { type: 'community-guidelines' },
                })
              "
            >
              {{ $t("About.communityGuidelines") }} </span
            >.
          </div> -->
        </div>
      </div>
    </div>
  </Popup>
</template>
<style scoped>
.linear-background {
  background: linear-gradient(
    rgba(0, 0, 0, 0.2) 0%,
    rgba(0, 0, 0, 0.2) 50%,
    rgba(0, 0, 0, 0) 100%
  );
}
</style>
